import React from "react";
import PropTypes from "prop-types";

export const ComposeDropDownMessage = ({ innerProps, children }) => {
    return (
        <div {...innerProps} className="compose-message-wrapper cursor-pointer">
            <span className="color-black mobile-number">{children}</span>
        </div>
    )
}

ComposeDropDownMessage.propTypes = {
    innerProps: PropTypes.object,
    children: PropTypes.string,
};